// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CalendarDay {
    --calendarColorDirection-Left: left;
    --calendarColorDirection-right: right;
}

.rtl .CalendarDay {
    --calendarColorDirection-Left: right;
    --calendarColorDirection-right: left;
}


.CalendarDay {
    border: none !important;
    border-radius: 50% !important;
    outline: none !important;
    background-color: var(--becomeHost-Available-Bg);
    color: var(--calendarDay-primary-foreground);
}

.CalendarDay:hover:not(.CalendarDay__selected):not(.CalendarDay__blocked_out_of_range):not(.CalendarDay__selected_span) {
    background-color: var(--calendarDay-primary-hover-bg);
    color: var(--calendarDay-primary-foreground);
}

.CalendarDay__blocked_out_of_range,
.CalendarDay__blocked_out_of_range:active,
.CalendarDay__blocked_out_of_range:hover {
    background: var(--becomeHost-disabled-day-bg);
    color: var(--becomeHost-disabled-day-foreground);
    cursor: not-allowed;
}


.CalendarDay__selected_start,
.CalendarDay__selected_start:active,
.CalendarDay__selected_start:hover {
    background: linear-gradient(to var(--calendarColorDirection-right) bottom, var(--becomeHost-Available-Bg) 50%, var(--calendarDay-primary-bg) 50%);
    color: var(--calendarDay-primary-foreground);
}

.CalendarDay__selected_end,
.CalendarDay__selected_end:active,
.CalendarDay__selected_end:hover {
    background: linear-gradient(to var(--calendarColorDirection-Left) top, var(--becomeHost-Available-Bg) 50%, var(--calendarDay-primary-bg) 50%);
    color: var(--calendarDay-primary-foreground);
}

.CalendarDay__selected_span,
.CalendarDay__selected_span:active,
.CalendarDay__selected_span:hover {
    background: var(--calendarDay-primary-bg);
    color: var(--calendarDay-primary-foreground);
}

.CalendarDay__hovered_span,
.CalendarDay__hovered_span:hover,
.CalendarDay__hovered_span:active {
    background: var(--calendarDay-primary-hover-bg);
    color: var(--calendarDay-primary-foreground);
}`, "",{"version":3,"sources":["webpack://./src/styles/reactDatesCalendar.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;AACxC;;;AAGA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,wBAAwB;IACxB,gDAAgD;IAChD,4CAA4C;AAChD;;AAEA;IACI,qDAAqD;IACrD,4CAA4C;AAChD;;AAEA;;;IAGI,6CAA6C;IAC7C,gDAAgD;IAChD,mBAAmB;AACvB;;;AAGA;;;IAGI,iJAAiJ;IACjJ,4CAA4C;AAChD;;AAEA;;;IAGI,6IAA6I;IAC7I,4CAA4C;AAChD;;AAEA;;;IAGI,yCAAyC;IACzC,4CAA4C;AAChD;;AAEA;;;IAGI,+CAA+C;IAC/C,4CAA4C;AAChD","sourcesContent":[".CalendarDay {\n    --calendarColorDirection-Left: left;\n    --calendarColorDirection-right: right;\n}\n\n.rtl .CalendarDay {\n    --calendarColorDirection-Left: right;\n    --calendarColorDirection-right: left;\n}\n\n\n.CalendarDay {\n    border: none !important;\n    border-radius: 50% !important;\n    outline: none !important;\n    background-color: var(--becomeHost-Available-Bg);\n    color: var(--calendarDay-primary-foreground);\n}\n\n.CalendarDay:hover:not(.CalendarDay__selected):not(.CalendarDay__blocked_out_of_range):not(.CalendarDay__selected_span) {\n    background-color: var(--calendarDay-primary-hover-bg);\n    color: var(--calendarDay-primary-foreground);\n}\n\n.CalendarDay__blocked_out_of_range,\n.CalendarDay__blocked_out_of_range:active,\n.CalendarDay__blocked_out_of_range:hover {\n    background: var(--becomeHost-disabled-day-bg);\n    color: var(--becomeHost-disabled-day-foreground);\n    cursor: not-allowed;\n}\n\n\n.CalendarDay__selected_start,\n.CalendarDay__selected_start:active,\n.CalendarDay__selected_start:hover {\n    background: linear-gradient(to var(--calendarColorDirection-right) bottom, var(--becomeHost-Available-Bg) 50%, var(--calendarDay-primary-bg) 50%);\n    color: var(--calendarDay-primary-foreground);\n}\n\n.CalendarDay__selected_end,\n.CalendarDay__selected_end:active,\n.CalendarDay__selected_end:hover {\n    background: linear-gradient(to var(--calendarColorDirection-Left) top, var(--becomeHost-Available-Bg) 50%, var(--calendarDay-primary-bg) 50%);\n    color: var(--calendarDay-primary-foreground);\n}\n\n.CalendarDay__selected_span,\n.CalendarDay__selected_span:active,\n.CalendarDay__selected_span:hover {\n    background: var(--calendarDay-primary-bg);\n    color: var(--calendarDay-primary-foreground);\n}\n\n.CalendarDay__hovered_span,\n.CalendarDay__hovered_span:hover,\n.CalendarDay__hovered_span:active {\n    background: var(--calendarDay-primary-hover-bg);\n    color: var(--calendarDay-primary-foreground);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
